.container {
  margin: 0 auto;
  padding: 48px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .header {
    font-size: 33px !important;
    font-weight: 400 !important;
    margin-bottom: 24px !important;
  }

  .message {
    max-width: 450px;
    font-size: 16px;
    margin-bottom: 32px;
  }

  button {
    max-width: 166px;
  }
}
